// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var UserContextHandler = (function () {
    function UserContextHandler() {
        this.context = {};
    }
    UserContextHandler.prototype.initializeContext = function (context) {
        this.context = this.replaceInvalidCharacterInContext(context);
        return this;
    };
    UserContextHandler.prototype.setContext = function (key, value) {
        this.context[this.replaceInvalidCharacters(key)] = value;
        return this;
    };
    UserContextHandler.prototype.getContext = function () {
        return this.context;
    };
    UserContextHandler.prototype.replaceInvalidCharacterInContext = function (context) {
        var _this = this;
        var validContext = {};
        Object.keys(context).forEach(function (key) {
            validContext[_this.replaceInvalidCharacters(key)] = context[key];
        });
        return validContext;
    };
    UserContextHandler.prototype.replaceInvalidCharacters = function (key) {
        if (typeof key === "string") {
            return key.replace(UserContextHandler.invalidCharacters, "_");
        }
        else {
            console.error("The user context key '{key}' is not a string.");
            return "";
        }
    };
    UserContextHandler.invalidCharacters = /[^A-Za-z0-9_]/ig;
    return UserContextHandler;
}());
exports.__esModule = true;
exports["default"] = UserContextHandler;



//////////////////
// WEBPACK FOOTER
// ./UserContext/UserContextHandler.ts
// module id = 19
// module chunks = 0